import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { selectAuthUser } from '../../redux/auth/auth.selectors';
import {
    invitationVerifyRequest,
    invitationAcceptRequest,
    invitationReset,
} from '../../redux/invitation/invitation.actions';
import {
    selectInvitationData,
    selectInvitationIsLoading,
    selectInvitationError,
    selectInvitationAcceptStatus,
} from '../../redux/invitation/invitation.selectors';

import LoaderSimple from '../../components/Loaders/LoaderSimple/LoaderSimple.js';
import Logo2 from '../../components/Logo/Logo2';

import './Auth.scss';


const Invitation = () => {
    document.title = 'Workspace Invitation - DB Design';

    const dispatch = useDispatch();
    const history = useHistory();
    const { token } = useParams();

    const currentUser = useSelector(selectAuthUser);
    const invitationData = useSelector(selectInvitationData);
    const isLoading = useSelector(selectInvitationIsLoading);
    const error = useSelector(selectInvitationError);
    const acceptStatus = useSelector(selectInvitationAcceptStatus);


    // Verify token on mount
    useEffect(() => {
        if (token) {
            dispatch(invitationVerifyRequest(token));
        }
        return () => {
            dispatch(invitationReset());
        };
    }, [token, dispatch]);

    // Redirect after successful accept
    useEffect(() => {
        if (acceptStatus === 'success') {
            history.push('/diagrams/');
        }
    }, [acceptStatus, history]);

    const handleAcceptClick = () => {
        dispatch(invitationAcceptRequest(token));
    };

    const handleJoinClick = () => {
        // history.push(`/signup?i=${token}`);
    };

    const handleSignInClick = () => {
        // history.push(`/login?i=${token}`);
    };

    const handleBackClick = () => {
        history.push('/login');
    };

    // No token in URL
    if (!token) {
        return (
            <div className="sign-in-box">
                <Logo2 />
                <div className="sign-in-wrap">
                    <div className="sign-in">
                        <div className="sign-in-title">Invalid Invitation</div>
                        <p className="invitation-text">No invitation token provided.</p>
                        <button
                            className="auth-btn-back"
                            type="button"
                            onClick={handleBackClick}
                        >Back to login</button>
                    </div>
                </div>
            </div>
        );
    }

    // Loading state
    if (isLoading && !invitationData) {
        return (
            <div className="sign-in-box">
                <Logo2 />
                <div className="sign-in-wrap">
                    <div className="sign-in">
                        <div className="sign-in-title">Verifying Invitation</div>
                        <div className="invitation-loader">
                            <LoaderSimple />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Error state
    if (error) {
        return (
            <div className="sign-in-box">
                <Logo2 />
                <div className="sign-in-wrap error">
                    <div className="sign-in">
                        <div className="sign-in-title">Invitation Error</div>
                        <p className="invitation-text">{error.message || 'This invitation is invalid or has expired.'}</p>
                        <button
                            className="auth-btn-back"
                            type="button"
                            onClick={handleBackClick}
                        >Back to login</button>
                    </div>
                </div>
            </div>
        );
    }

    // Invitation verified
    if (invitationData) {
        return (
            <div className="sign-in-box">
                <Logo2 />
                <div className="sign-in-wrap">
                    <div className="sign-in">

                        <div className="sign-in-title">You're invited</div>

                        <div className="invitation-info">
                            {invitationData.inviterName && (
                                <p className="invitation-text">
                                    <span className="invitation-highlight">{invitationData.inviterName}</span> has invited you to join
                                </p>
                            )}
                            <p className="invitation-workspace-name">
                                {invitationData.workspaceName || 'a workspace'}
                            </p>
                        </div>

                        {/* User is logged in — show Accept button */}
                        {currentUser ? (
                            <div className="invitation-actions">
                                <button
                                    disabled={isLoading}
                                    className="auth-btn-submit"
                                    type="button"
                                    onClick={handleAcceptClick}
                                >{isLoading ? <LoaderSimple /> : 'Accept Invitation'}</button>

                                {acceptStatus === 'error' && (
                                    <p className="invitation-error-text">Failed to accept invitation. Please try again.</p>
                                )}
                            </div>
                        ) : (
                            <div className="invitation-actions">
                                <button
                                    className="auth-btn-submit"
                                    type="button"
                                    onClick={handleJoinClick}
                                >Join Workspace</button>

                                <p className="invitation-signin-text">
                                    Already have an account?{' '}
                                    <button
                                        className="invitation-link-btn"
                                        type="button"
                                        onClick={handleSignInClick}
                                    >Sign in</button>
                                </p>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        );
    }

    return null;
};

export default Invitation;
